module.exports = __webpack_public_path__ + "static/media/fvs_valve1_71.55d12ee6.jpg";